import React__default from 'react';
import styled, { css } from 'styled-components';
import { Button } from '../button/Button.js';
import { COLOR_PALETTE } from '../colors/colorPalette.js';
import { Box } from '../layout/Box.js';
import { Inline } from '../layout/Inline.js';
import { Stack } from '../layout/Stack.js';
import { getColor } from '../styles/stylePropTypes.js';

const StyledButton = styled(Button)`
  height: 1.5rem;
  font-size: 0.875rem;
  font-weight: 600;

  border-bottom: 2px solid transparent;
  border-radius: 0;
  background-color: transparent;
  padding: 0;
  padding-bottom: 0.5rem;
  min-width: 0;

  /* Have the hover indicator sit on top of the tabs divider. */
  margin-bottom: -1px;
  z-index: 2;

  &:focus {
    background: transparent;
    outline: none;
  }

  &:hover {
    background: transparent;
    border-color: ${(props)=>getColor("context", props.theme)};
    color: ${(props)=>getColor("context", props.theme)};
  }

  ${(props)=>props.$active && css`
      background: transparent;
      border-color: ${(props)=>getColor("context", props.theme)};
      color: ${(props)=>getColor("context", props.theme)};
    `}
`;
const Tab = ({ active , testId , children , ...props })=>{
    return React__default.createElement(StyledButton, {
        "data-hpy-web-tab": true,
        ...props,
        "$active": active,
        testId: "Tab-" + testId
    }, children);
};
Tab.dataId = "data-hpy-web-tab";
Tab.displayName = "Tab";
const StyledStack = styled(Stack)`
  &[data-hpy-web-stack] {
    border-bottom: 1px solid ${COLOR_PALETTE.slateGrey10};
  }
`;
const Tabs = ({ children , ...props })=>{
    return React__default.createElement(StyledStack, {
        "data-hpy-web-tabs": true,
        ...props
    }, React__default.createElement(Box, null, React__default.createElement(Inline, {
        gap: 1.5
    }, children)));
};
Tabs.dataId = "data-hpy-web-tabs";
Tabs.displayName = "Tabs";

export { Tab, Tabs };
